import { CheckboxItem } from '@pc/common';

export function isDate(dateStr: string) {
  return !isNaN(new Date(dateStr).getDate());
}

export function removeTimeFromDate(date: Date): Date {
  return new Date(
    date.getFullYear() +
      '-' +
      String(date.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(date.getDate()).padStart(2, '0')
  );
}

export function enumToList<T extends object>(enumObj: T, map: { [key: string]: string }): CheckboxItem[] {
  return Object.keys(enumObj).map((key) => ({
    checked: false,
    text: map[key] ?? '',
    value: enumObj[key as keyof typeof enumObj] as string
  }));
}

export const pxToRem = (pxValue: number): number => {
  // Retrieve the base font size in pixels from the CSS
  const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

  return pxValue / baseFontSize;
};
